import React, { useEffect, useState } from 'react';
import { ROLES } from '../../constants';
import { getItem, hasRoles } from '../../utils';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import MaterialTable from 'material-table';

import Modal from '../Modal';

export default function Instances({ instanceId, setInstanceId }) {
  const classes = useStyles();
  const token = getItem('accessToken');

  const [instances, setInstances] = useState([]);
  const [showInstanceManagement, setShowInstanceManagement] = useState(false);

  useEffect(() => {
    if (!token) return;
    const user = jwtDecode(token);
    if (hasRoles(user, [ROLES.SUPER_ADMIN])) {
      getAllInstances();
    }
  }, [token]);

  function getAllInstances() {
    axios.get('/api/instances').then(({ data: instances }) => setInstances(instances));
  }

  async function addInstance(instance) {
    await axios.post('/api/instances', instance);
    await getAllInstances();
  }

  async function updateInstance(instance) {
    await axios.put('/api/instances/' + instance.id, instance);
    await getAllInstances();
  }

  async function deleteInstance(instance) {
    await axios.delete('/api/instances/' + instance.id);
    await getAllInstances();
  }

  function onInstanceChange(e) {
    const newInstance = e.target.value;
    if (newInstance === 'add') {
      // Show manage instance modal
      setShowInstanceManagement(true);
    } else {
      setInstanceId(newInstance);
    }
  }

  return (
    <>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={instanceId}
        onChange={onInstanceChange}
        classes={{ root: classes.root, icon: classes.icon }}
        disableUnderline
      >
        <MenuItem key="add" value="add">
          Manage
        </MenuItem>
        {instances.map((instance) => (
          <MenuItem key={instance.id} value={instance.id}>
            {instance.name}
          </MenuItem>
        ))}
      </Select>

      <Modal isOpen={showInstanceManagement} onClose={() => setShowInstanceManagement(false)} fullWidth={true} maxWidth="xl">
        <MaterialTable
          style={{
            boxShadow: 'none',
          }}
          title="Manage instances"
          columns={[
            { title: 'Name', field: 'name' },
            { title: 'SMS sent', field: 'smsSent', editable: 'never' },
          ]}
          options={{
            paging: false,
          }}
          data={instances}
          editable={{
            onRowAdd: addInstance,
            onRowUpdate: updateInstance,
            onRowDelete: deleteInstance,
          }}
        />
      </Modal>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(5),
    color: 'white',
  },
  icon: {
    color: 'white',
  },
}));
